import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import { ifAuthenticated } from "../access";

import PushDetail from "@/pages/Pages/Push/PushDetail.vue";
import PushDetailInfo from "@/pages/Pages/Push/PushDetailInfo.vue";
import PushGroup from "@/pages/Pages/Push/PushGroup.vue";
import PushSubscribersCount from "@/pages/Pages/Push/PushSubscribersCount.vue";
import PushHistory from "@/pages/Pages/Push/PushHistory.vue";
import PushPartnerTariffs from "@/pages/Pages/Push/PushPartnerTariffs.vue";
import PushPartnerTariff from "@/pages/Pages/Push/PushPartnerTariff.vue";
import PushTemplates from "@/pages/Pages/Push/PushTemplates.vue";
import PushTemplate from "@/pages/Pages/Push/PushTemplate.vue";
import ApplicationAttributes from "@/pages/Pages/Push/ApplicationAttributes.vue";
import ApplicationAttribute from "@/pages/Pages/Push/ApplicationAttribute.vue";
import PushApplications from "@/pages/Pages/Push/PushApplications.vue";
import PushApplication from "@/pages/Pages/Push/PushApplication.vue";
import PushSubscribers from "@/pages/Pages/Push/PushSubscribers.vue";
import PushDevice from "@/pages/Pages/Push/PushDevice.vue";
import PushDevices from "@/pages/Pages/Push/PushDevices.vue";
import PushSubscriber from "@/pages/Pages/Push/PushSubscriber.vue";
import PushGroupsApplications from "@/pages/Pages/Push/PushGroupsApplications.vue";
import PushGroupsApplication from "@/pages/Pages/Push/PushGroupsApplication.vue";

const pushMenu = {
  path: "/push",
  component: DashboardLayout,
  beforeEnter: ifAuthenticated,
  redirect: "/push/detail",
  name: "Push",
  children: [
    {
      path: "templates",
      name: "push_templates",
      components: { default: PushTemplates },
      meta:{
        icon: "notifications",
        msgKey: 'menu.item.push.templates'
      }
    },
    {
      path: "templates/new",
      name: "push_templates_new",
      components: { default: PushTemplate },
      meta:{
        icon: "notifications",
        parentPath: "/push/templates",
        msgKey: 'menu.item.push.templates'
      },
    },
    {
      path: "templates/:id",
      name: "push_templates_edit",
      components: { default: PushTemplate },
      meta:{
        icon: "notifications",
        parentPath: "/push/templates",
        msgKey: 'menu.item.push.templates'
      }
    },
    {
      path: "detail",
      name: "push_detail",
      components: { default: PushDetail },
      meta: {
        icon: "notifications",
        msgKey: 'menu.item.statistics.push.detail'
      }
    },
    {
      path: "detail/:id",
      name: "push_detail_info",
      components: { default: PushDetailInfo },
      meta:{
        icon: "push",
        parentPath: "/push/detail",
        msgKey: 'menu.item.statistics.push.detail'
      }
    },
    {
      path: "group",
      name: "push_group",
      components: { default: PushGroup },
      meta: {
        icon: "notifications",
        msgKey: 'menu.item.statistics.push.group'
      }
    },
    {
      path: "subscribers_count",
      name: "push_subscribers_count",
      components: { default: PushSubscribersCount },
      meta: {
        icon: "notifications",
        msgKey: "menu.item.push.subscribers",
      }
    },
    {
      path: "history",
      name: "push_history",
      components: { default: PushHistory },
      meta: {
        icon: "notifications",
        msgKey: "menu.item.push.history",
      }
    },
    {
      path: "applications/attributes",
      name: "attributes",
      components: { default: ApplicationAttributes },
      meta:{
        icon: "notifications",
        msgKey: 'menu.item.push.app.attribute'
      }
    },
    {
      path: "applications/:application_id/attributes/new",
      name: "attributes_new",
      components: { default: ApplicationAttribute },
      meta:{
        icon: "notifications",
        parentPath: "/push/applications/attributes",
        msgKey: 'menu.item.push.app.attribute'
      },
    },
    {
      path: "applications/:application_id/attributes/:id",
      name: "attributes_edit",
      components: { default: ApplicationAttribute },
      meta:{
        icon: "notifications",
        parentPath: "/push/applications/attributes",
        msgKey: 'menu.item.push.app.attribute'
      },
    },
    {
      path: "applications",
      name: "push_applications",
      components: { default: PushApplications },
      meta:{
        icon: "notifications",
        msgKey: 'menu.item.push.applications'
      }
    },
    {
      path: "applications/new",
      name: "push_applications_new",
      components: { default: PushApplication },
      meta:{
        icon: "notifications",
        parentPath: "/push/applications",
        msgKey: 'menu.item.push.applications'
      },
    },
    {
      path: "applications/:id",
      name: "push_applications_edit",
      components: { default: PushApplication },
      meta:{
        icon: "notifications",
        parentPath: "/push/applications",
        msgKey: 'menu.item.push.applications'
      },
    },
    {
      path: "subscribers",
      name: "push_subscribers",
      components: { default: PushSubscribers },
      meta:{
        icon: "notifications",
        msgKey: 'menu.item.push.subscribers.management'
      }
    },
    {
      path: "subscribers/:id",
      name: "push_subscribers_edit",
      components: { default: PushSubscriber },
      meta:{
        icon: "notifications",
        parentPath: "/push/subscribers",
        msgKey: 'menu.item.push.subscribers.management'
      },
    },
    {
      path: "devices",
      name: "push_devices",
      components: { default: PushDevices },
      meta:{
        icon: "notifications",
        msgKey: 'menu.item.push.devices.management'
      }
    },
    {
      path: "devices/:id",
      name: "push_devices_edit",
      components: { default: PushDevice },
      meta:{
        icon: "notifications",
        parentPath: "/push/devices",
        msgKey: 'menu.item.push.devices.management'
      },
    },
    {
      path: "groups_applications",
      name: "push_groups_applications",
      components: { default: PushGroupsApplications },
      meta:{
        icon: "notifications",
        msgKey: 'menu.item.push.applications'
      }
    },
    {
      path: "groups_applications/new",
      name: "push_groups_applications_new",
      components: { default: PushGroupsApplication },
      meta:{
        icon: "notifications",
        parentPath: "/push/groups_applications",
        msgKey: 'menu.item.push.applications'
      },
    },
    {
      path: "groups_applications/:id",
      name: "push_groups_applications_edit",
      components: { default: PushGroupsApplication },
      meta:{
        icon: "notifications",
        parentPath: "/push/groups_applications",
        msgKey: 'menu.item.push.applications'
      },
    },
    {
      path: "partners/tariffs",
      name: "push_client_tariff",
      components: { default: PushPartnerTariffs },
      meta: {
        icon: "notifications",
        msgKey: 'menu.item.push.clients.tariff'
      }
    },
    {
      path: "partners/tariffs/new",
      name: "push_client_tariff_new",
      components: { default: PushPartnerTariff },
      meta:{
        icon: "notifications",
        parentPath: "/push/partners/tariffs",
        msgKey: 'menu.item.push.clients.tariff'
      },
    },
    {
      path: "partners/tariffs/:id",
      name: "push_client_tariff_edit",
      components: { default: PushPartnerTariff },
      meta:{
        icon: "notifications",
        parentPath: "/push/partners/tariffs",
        msgKey: 'menu.item.push.clients.tariff'
      }
    },
  ],
};

export default pushMenu;
